// extracted by mini-css-extract-plugin
export default {"Container":"Cards_Container__BmoM1","Cards-wrapper":"Cards_Cards-wrapper__IMNi7","card":"Cards_card__VK+YI","icon-wrapper":"Cards_icon-wrapper__Mc4oB"};